import {
  Button,
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from '@see-ui/core';
import { logout as logoutapi } from '@services/api/login-service';
import { useGlobalStore } from '@services/store/global-store';
import { useEffect, useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { useNavigate } from 'react-router';
import { useAuth } from '../context/AuthContext';

const IdleTimer: React.FC = () => {
  const [showModal, setshowModal] = useState(false);
  const [countdown, setCountdown] = useState(0);
  const { logout } = useAuth();
  const warningTimeout = 60; // Warning period in seconds
  const idleTimeout = 1000 * 60 * 30; // Idle timeout in milliseconds (30 minutes)
  //const idleTimeout = 1000 * 10;
  const navigate = useNavigate();
  const { userDetails } = useGlobalStore();
  const cceName = useGlobalStore.getState().userDetails.userInformation.cceName;
  const userSubType =
    useGlobalStore.getState().userDetails.userInformation.userSubType;
  const isAuthenticated =
    userDetails.jwtToken && userDetails.jwtToken.length > 0;

  useEffect(() => {
    let interval: NodeJS.Timeout | null = null;
    const endTime = Date.now() + countdown * 1000;

    if (showModal) {
      interval = setInterval(() => {
        const remainingTime = Math.round((endTime - Date.now()) / 1000);

        if (remainingTime <= 0) {
          clearInterval(interval!);
          setshowModal(false);
          console.log(
            'Logging out due to inactivity',
            new Date().toLocaleTimeString()
          );
          handleLogout();
        } else {
          setCountdown(remainingTime);
        }
      }, 1000);
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [showModal]);

  const onIdle = () => {
    console.log('IdleTimer: onIdle triggered at', new Date().toISOString());
    console.log('IdleTimer: onIdle triggered', {
      pathname: window.location.pathname,
      timestamp: new Date().toISOString()
    });
    if (!window.location.pathname.includes('login')) {
      console.log('IdleTimer: Setting modal to show');
      setshowModal(true);
      setCountdown(warningTimeout);
    }
  };

  const { reset, pause, resume } = useIdleTimer({
    timeout: idleTimeout,
    onIdle,
    debounce: 500,
    onActive: () => console.log('User became active'),
    startOnMount: Boolean(isAuthenticated), // Convert to proper boolean
    events: [
      'mousedown',
      'mousemove',
      'keypress',
      'scroll',
      'touchstart',
      'click'
    ]
  });

  useEffect(() => {
    if (!isAuthenticated) {
      pause();
      setshowModal(false);
      setCountdown(0);
    } else {
      resume();
    }
  }, [isAuthenticated, pause, resume]);

  const handleClose = () => {
    setshowModal(!showModal);
  };

  const removeLivePersonScript = () => {
    const script = document.querySelector(
      'script[src*="lptag.liveperson.net"]'
    );
    if (script) {
      document.head.removeChild(script);
    }
    // window.location.reload();
  };

  const handleLogout = async () => {
    setshowModal(false);
    // await logoutapi();
    try {
      await logoutapi();
    } catch (error) {
      console.log('Logout API failed, continuing with local logout:');
    }
    removeLivePersonScript();
    logout();
    // if (userSubType === 'SSO' && cceName !== 'CCWW') {
    //   navigate(ROUTES.SSO_LOGOUT);
    // } else {
    //   logout();
    //   navigate(ROUTES.LOGIN);
    // }
  };

  return (
    <>
      {showModal && !window.location.pathname.includes('login') && (
        <Dialog open={showModal}>
          <DialogContent className="justify-center">
            <DialogHeader>
              <DialogTitle>You Have Been Idle!</DialogTitle>
              <DialogDescription></DialogDescription>
            </DialogHeader>
            You Will Get Timed Out in {countdown} seconds due to inactivity, You
            want to stay?
            <DialogFooter className="md:justify-center">
              <DialogClose asChild>
                <Button
                  type="button"
                  variant="secondary"
                  onClick={handleLogout}
                >
                  Logout
                </Button>
              </DialogClose>
              <DialogClose asChild>
                <Button type="button" variant="primary" onClick={handleClose}>
                  Continue
                </Button>
              </DialogClose>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};

export default IdleTimer;
